.tab {
  padding: 0 16px 8px;
  font-size: var(--fs-normal);
  font-weight: 400;
  color: var(--static-text-strong);
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
  height: 31.5px;
}

.tab::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: transparent;
  transition: background-color 0.2s ease;
}

.tab:hover::after {
  background-color: var(--primary-hover);
}

.activeTab {
  font-weight: 600;
}

.activeTab::after {
  background-color: var(--primary-active);
}

.tabsWrapper {
  border-bottom: 1px solid var(--static-divider-standard);
}